<template>
  <div class="create" @keyup.13="submit">
    <mu-dialog title="新增支出" width="500" :open="open" @close="close">
      <mu-form :model="form" label-position="left" label-width="100" ref="form">
        <mu-form-item prop="name" label="名称">
          <mu-text-field v-model="form.name"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="price" label="单价">
          <mu-text-field v-model.number="form.price"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="unit" label="单位">
          <mu-select v-model="form.unit">
            <mu-option
              v-for="(item, index) in unitList"
              :key="index"
              :label="item"
              :value="item"
            ></mu-option>
          </mu-select>
        </mu-form-item>

        <mu-form-item prop="outCategory" label="分类">
          <mu-select v-model="form.outCategory">
            <mu-option
              v-for="(item, index) in outCategoryList"
              :key="index"
              :label="item.name"
              :value="item"
            ></mu-option>
          </mu-select>
        </mu-form-item>

        <mu-form-item prop="count" label="数量">
          <mu-text-field v-model.number="form.count"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="sum" label="总价">
          <mu-text-field v-model="form.sum" disabled></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="sum" label="备注">
          <mu-text-field v-model="form.remark"></mu-text-field>
        </mu-form-item>

        <!-- <mu-form-item prop="record" label="音频">
          <mu-text-field v-model="form.record"></mu-text-field>
        </mu-form-item> -->

        <!-- <mu-form-item prop="images" label="图片">
          <mu-text-field v-model="form.images"></mu-text-field>
        </mu-form-item> -->

        <!-- <mu-form-item prop="status" label="状态">
          <mu-text-field v-model="form.status"></mu-text-field>
        </mu-form-item> -->

        <mu-form-item prop="account" label="账户">
          <mu-select v-model="form.account">
            <mu-option
              v-for="(item, index) in user.accounts"
              :key="index"
              :label="item.name"
              :value="item"
            ></mu-option>
          </mu-select>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        name: '',
        price: '',
        unit: '件',
        count: 1,
        sum: '',
        record: '',
        status: '未审核',
        account: '',
        remark: '',
        outCategory: ''
      },
      unitList: ['件', '张', '套', '箱', '个', '平米', '千克', '斤', '其他'],
      outCategoryList: []
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate().then((flag) => {
        if (flag) {
          backend(api.out.create, this.form).then((result) => {
            if (result.statusCode === 200) {
              this.close()
              this.$emit('finish')
              this.form = {
                name: '',
                price: '',
                unit: '件',
                count: 1,
                sum: '',
                record: '',
                status: '',
                remark: '',
                account: this.user.accounts[0],
                outCategory: this.outCategoryList[0]
              }
            }
          })
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    },
    getOutCategory() {
      backend(api.outcategory.getAll, { getAll: true }).then((result) => {
        if (result.statusCode === 200) {
          this.outCategoryList = result.data.rows
          this.form.outCategory = result.data.rows[0]
        }
      })
    }
  },
  watch: {
    'form.price': {
      handler(value) {
        this.form.sum = this.form.price * this.form.count
      },
      deep: true
    },
    'form.count': {
      handler(value) {
        this.form.sum = this.form.price * this.form.count
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  mounted() {
    this.form.account = this.user.accounts[0]
    this.getOutCategory()
  }
}
</script>

<style lang="less" scoped>
.create {
}
</style>



// WEBPACK FOOTER //
// src/views/out/create.vue